// extracted by mini-css-extract-plugin
export default {"container":"detailBlog_container__xz6ed"};